import * as Yup from 'yup';

import { withMerchantFunction } from '../../utils/merchantUtils';

import {
  getContactsRule,
  getExperienceSettingsRule,
  getNameRule,
  getPaymentMethodRule,
  getProductsRule,
  getSettingsRule
} from './common';

//! Step 5
const getReviewAndPayRule = ({
  isPaymentMethodRequired = false,
  isEndDateRequired = true,
  isInputMessageRequired = true
}) => {
  return Yup.object().shape({
    products: getProductsRule(),
    paymentMethod: getPaymentMethodRule(isPaymentMethodRequired),
    name: getNameRule('recognition'),
    experienceSettings: getExperienceSettingsRule(isInputMessageRequired),
    settings: getSettingsRule({ isEndDateRequired }),
    contacts: getContactsRule({ featureName: 'recognition' })
  });
};

const getReviewAndPaySchema = withMerchantFunction({
  defaultFunction: getReviewAndPayRule,
  fileName: 'recognitions',
  folderPath: 'validations'
});

export { getReviewAndPaySchema };
